import React from 'react'
import {EuiSpacer} from '@elastic/eui'

type Props = {
    size? :'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'
}

const ComponentEuiSpacer = ({size}: Props) => <EuiSpacer size={size}/>

export default ComponentEuiSpacer